import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Compiler, COMPILER_OPTIONS, CompilerFactory, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { AppComponent } from "./app.component";
import { RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { httpInterceptorProviders } from "./http-interceptors/index";
import { AdminFeatureModule } from "./views/admin-feature/admin-feature.module";
import { AttendeeFeatureModule } from "./views/attendee-feature/attendee-feature.module";
import {
    CclLayoutModule,
    CclFormsModule,
    CclDrawerService,
    CclLocalStorageService,
    CclPopupService,
    CclSharedModule
} from "certain-common-library";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxSpinnerModule } from "ngx-spinner";
import { CookieModule } from "ngx-cookie";
import { JitCompilerFactory } from "@angular/platform-browser-dynamic";
import { SharedModule } from "./views/shared-module/shared-module";
export function createCompiler(compilerFactory: CompilerFactory) {
    return compilerFactory.createCompiler();
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        CclLayoutModule,
        CclFormsModule,
        CclSharedModule,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        HttpClientModule,
        AdminFeatureModule,
        AttendeeFeatureModule,
        DragScrollModule,
        RouterModule.forRoot([{ path: "**", redirectTo: "" }], { useHash: true, relativeLinkResolution: 'legacy' }),
        NgxSpinnerModule,
        CookieModule.forRoot(),
        SharedModule
    ],
    providers: [
        CclDrawerService,
        CclLocalStorageService,
        httpInterceptorProviders,
        CclPopupService,
        { provide: COMPILER_OPTIONS, useValue: {}, multi: true },
        { provide: CompilerFactory, useClass: JitCompilerFactory, deps: [COMPILER_OPTIONS] },
        { provide: Compiler, useFactory: createCompiler, deps: [CompilerFactory] }
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    bootstrap: [AppComponent]
})
export class AppModule {}